<template>
    <v-card>
        <v-card-title>
            <v-toolbar dense flat color="white">
                <v-toolbar-title>Elenco Clienti</v-toolbar-title>
                <v-divider
                        class="mx-2"
                        inset
                        vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="createSubject">Nuovo</v-btn>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Cerca..."
                        single-line
                        hide-details
                ></v-text-field>
            </v-toolbar>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="subjects"
                :loading="loading"
                class="elevation-1"
                select-all
                v-model="selected"
                item-key="Id"
                :search="search"
                :pagination.sync="pagination"
        >
            <template slot="items" slot-scope="props">
                <td>
                    <v-checkbox
                            v-model="props.selected"
                            primary
                            hide-details
                    ></v-checkbox>
                </td>
                <td>{{ props.item.VisibleName }}</td>
                <td>{{ props.item.FiscalCode }}</td>
                <td>{{ props.item.VatId }}</td>
                <td>{{ props.item.Country }}</td>
                <td>{{ props.item.OfficeProvince }}</td>
                <td>{{ props.item.OfficeCity }}</td>
                <td class="justify-center layout px-0">
                    <v-toolbar-items>
                        <v-tooltip bottom class="toolbar-fix">
                            <v-btn slot="activator" icon
                                   small
                                   class="mr-2"
                                   @click="editItem(props.item)"
                            >
                                <v-icon small>edit</v-icon>
                            </v-btn>
                            <span>Modifica</span>
                        </v-tooltip>

                        <v-tooltip bottom class="toolbar-fix">
                            <v-btn slot="activator" icon
                                   small
                                   class="mr-2"
                                   @click="showDeleteItemDialog(props.item)"
                            >
                                <v-icon small>delete</v-icon>
                            </v-btn>
                            <span>Elimina</span>
                        </v-tooltip>
                    </v-toolbar-items>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                La tua ricerca: "{{ search }}" non ha restituito risultati.
            </v-alert>
        </v-data-table>

        <div class="text-xs-center">
            <v-dialog
                    v-model="deleteDialog"
                    width="500"
            >
                <v-card>
                    <v-card-title
                            class="headline grey lighten-2"
                            primary-title
                    >
                        Elimina Cliente
                    </v-card-title>

                    <v-card-text>
                        Attenzione: una volta eliminato, un cliente non è più recuperabile.
                        <br>
                        Continuare?
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-btn
                                color="default"
                                flat
                                @click="deleteDialog = false"
                        >
                            Annulla
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="primary"
                                flat
                                @click="deleteItem(itemToDelete)"
                        >
                            Elimina
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </v-card>
</template>

<script>
    import SubjectsApi from '@/api/subjects'
    export default {
        name: "SubjectsList",
        data () {
            return {
                subjects: [],
                loading: true,
                pagination: {
                    rowsPerPage: 25
                },
                selected: [],
                headers: [
                    { text: 'Denominazione', align: 'left', value: 'VisibleName' },
                    { text: 'Codice Fiscale', align: 'left', value: 'FiscalCode' },
                    { text: 'Partita IVA', align: 'left', value: 'VatId' },
                    { text: 'Nazione', align: 'left', value: 'Country'},
                    { text: 'Provincia', align: 'left', value: 'OfficeProvince'},
                    { text: 'Comune', align: 'left', value: 'OfficeCity'},
                    { text: '', align: 'center', value: 'Id', sortable: false }
                ],
                search: '',
                itemToDelete: {},
                deleteDialog: false,
            }
        },
        mounted () {
            this.getDataFromApi();
        },
        methods: {
            getDataFromApi () {
                this.loading = true;
                SubjectsApi.getSubjects()
                    .then(t => {
                        this.subjects = t.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            },
            createSubject() {
                SubjectsApi.newSubject()
                    .then(t => {
                        this.$router.push({name:'subject', params: { id: t.data.Id }});
                    })
                    .catch(t => {
                        this.$root.showBottomError('Errore, contattare l\'assistenza',true);
                    })
            },
            editItem(item) {
                this.$router.push({name:'subject', params: { id: item.Id }});
            },
            showDeleteItemDialog(item) {
                this.itemToDelete = item;
                this.deleteDialog = true;
            },
            deleteItem(item) {
                SubjectsApi.deleteSubject(item.Id)
                    .then(t => {
                        this.subjects.splice(this.subjects.indexOf(item), 1);
                        this.$root.showBottomMessage('Cliente cancellato',false);
                    })
                    .finally(() => {
                        this.itemToDelete = {};
                        this.deleteDialog = false;
                    });
            }
        }
    }
</script>

<style scoped>
</style>